// extracted by mini-css-extract-plugin
module.exports = {"container":"ListNoData__container___SDY3C","item":"ListNoData__item___2UnIw","imgStyle":"ListNoData__imgStyle___3KX47"};